import React from "react";
import { Icon } from "semantic-ui-react";

// Shared page header for both Buyer and Seller Strategy pages - title,
// shared supporting copy, and an optional right-aligned action slot (Compare
// Homes / Add Property, Buyer only). Keeps both pages visually anchored by
// the same heading treatment rather than each inventing its own. `icon`
// (optional) adds a light-blue icon tile before the title.
export default function StrategyPageHeader({ title, actions, isMobile, icon }) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        justifyContent: "space-between",
        alignItems: isMobile ? "flex-start" : "center",
        gap: "12px",
        flexWrap: "wrap",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
        {icon && (
          <div
            aria-hidden="true"
            style={{
              width: 48, height: 48, borderRadius: 12, background: "#eaf4fc", flexShrink: 0,
              display: "flex", alignItems: "center", justifyContent: "center",
            }}
          >
            <Icon name={icon} style={{ margin: 0, color: "#2185d0", fontSize: "1.4em" }} />
          </div>
        )}
        <div>
          <h2 className="zero bottom margin" style={icon ? { color: "#16243c" } : undefined}>{title}</h2>
          <p className="small top margin zero bottom margin text-grey">
            AI-powered property insights and transaction strategies.
          </p>
        </div>
      </div>
      {actions && (
        <div style={{ display: "flex", gap: "10px", flexWrap: "wrap", width: isMobile ? "100%" : "auto" }}>
          {actions}
        </div>
      )}
    </div>
  );
}
